<div class="checkbox">
  <input
    type="checkbox"
    [id]="id"
    (change)="toggle()"
    [checked]="checked"
    class="checkbox__input checkbox__square"
    />

    <span class="checkbox__custom-input checkbox__square">
      <i class="fas fa-check"></i>
    </span>

    @if (label) {
      <label
        [for]="id"
        class="checkbox__label"
        >
        {{ label }}
      </label>
    }
  </div>